@if (!fullScreen && showText) {
    <app-totem-widget-text [abstract]="showText.abstract" [subAbstract]="showText.subAbstract" [logo]="showText.logo" [logoInvert]="showText.logoInvert" [cover]="showText.cover" [background]="showText.background" [abstractColor]="showText.abstractColor"
        (requestFullScreen)="onRequestFullScreen()"></app-totem-widget-text>
}
@else {
    @if (productsData == null) {
        <div class="h-100 py-3 position-relative">
            <app-pg-loading [isOverlay]="true"></app-pg-loading>
        </div>
    }
    @else {
        @if (!fullScreen) {
            @if (!showMap) {
                <div class="TotemWidgetProducts TotemWidgetProducts-ProductList {{verticalList ? 'TotemWidgetProducts-ProductList--Vertical' : 'TotemWidgetProducts-ProductList--Horizontal'}}">
                    <app-ef-list [productsData]="filteredData" [vertical]="verticalList" (showProduct)="onShowProduct($event)"></app-ef-list>
                </div>
            }
            @if (showMap) {
                <div class="TotemWidget TotemWidgetProducts TotemWidgetProducts-Map card {{fullScreen ? 'TotemWidgetProducts--FullScreen' : '' }}">
                    <div class="TotemWidgetProducts-Content">
                        @if (!fullScreen) {
                            @if (!noFullScreen) {
                                <div class="p-2">
                                    <button type="button" class="btn btn-light btn-sm" (click)="onRequestFullScreen()">
                                        {{ 'totem-a11y.open-map-list' | locTranslate }}
                                    </button>
                                </div>
                            }
                            <app-ef-map #efMapComponent [productsData]="filteredData" (showProduct)="onShowProduct($event)"></app-ef-map>
                        }
                    </div>
                </div>
            }
        }
        @else {
            <div class="TotemWidget TotemWidgetProducts TotemWidgetProducts--FullScreen">
                <div class="TotemWidgetProducts-Content {{ selectedProductId != null ? 'TotemWidgetProducts-Content--Product' : 'TotemWidgetProducts-Content--Main' }}">
                    <!-- perché qua non passo filteredData invece di productsData e externalFilter generato? -->
                    @if (selectedProductId == null) {
                        <app-ef-main appMode="iframekiosk" [setView]="fullScreenView" [productsList]="productsData" [externalFilter]="externalFilter" [mixTypes]="mixTypes" [hasBack]="false" (goBack)="hideFullScreen.emit()"></app-ef-main>
                    }
                    @if (selectedProductId != null) {
                        @if (isLoadingProduct) {
                            <app-pg-loading></app-pg-loading>
                        }
                        @if (!isLoadingProduct) {
                            <app-ef-product appMode="iframekiosk" [productData]="selectedProductData" [supplierData]="selectedProductSupplierData" [hasBack]="false" (goBack)="hideFullScreen.emit()" (showProduct)="onShowProduct($event)" (showStop)="onShowStop($event)"></app-ef-product>
                        }
                    }
                </div>
            </div>
        }
    }
}
